document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('.mega-menu__mobile-toggle');
  const mobileNav = document.querySelector('.mega-menu__mobile-nav');
  const mobileOverlay = document.querySelector('.mega-menu__mobile-overlay');
  const mobileClose = document.querySelector('.mega-menu__mobile-close');

  const openMobileMenu = () => {
    if (!mobileNav || !mobileOverlay) return;
    mobileNav.classList.add('is-open');
    mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMobileMenu = () => {
    if (!mobileNav || !mobileOverlay) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const toggleSubmenu = (button) => {
    const submenuId = button.getAttribute('data-submenu-id');
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    submenu.classList.toggle('is-open');
  };

  if (mobileToggle) {
    mobileToggle.addEventListener('click', openMobileMenu);
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileMenu);
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  document.querySelectorAll('.mega-menu__mobile-submenu-toggle').forEach(button => {
    button.addEventListener('click', () => toggleSubmenu(button));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });
  
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) {
      closeMobileMenu();
    }
  });
});
